import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";

import { Card, Icon, IconButton, Modal, Table, TableBody, TableRow } from "@mui/material";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "40%",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
};

function MDModalPerfis({
    dados,
    show,
    close,
    header }) {

    return (
        <Modal
            open={show}
            onClose={close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Card sx={style}>
                <MDTypography id="modal-modal-title" variant="h6" component="h2" mb={1}>
                    {header}
                </MDTypography>
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{ position: 'absolute', top: 10, right: 8 }} >
                    <MDTypography variant="body1" lineHeight={1}>
                        <Icon color="light">close</Icon>
                    </MDTypography>
                </IconButton>
                <Table sx={{ minWidth: 200 }}>
                    <TableBody>
                        {dados && dados.length > 0 ? (
                            dados.map((item, index) => (
                                <TableRow key={index}>
                                    <DataTableBodyCell>
                                        {item.descricao || item.razaoSocial || item.nome || "-"}
                                    </DataTableBodyCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <DataTableBodyCell colSpan={2} align="center">
                                    Nenhum dado disponível
                                </DataTableBodyCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Card>
        </Modal>
    );
}

// Typechecking props for the MDDatePicker
MDModalPerfis.propTypes = {
    show: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    dados: PropTypes.array.isRequired
};

export default MDModalPerfis;
